import styled from 'styled-components';
import { ToggleButton } from '@libs/uikit/Components';

export const StyledTB = styled(ToggleButton)`
	&:first-child {
		border-radius: 30px 0 0 30px;
	}

	&:last-child {
		border-radius: 0 30px 30px 0;
	}
	background-color: ${props => props.active ? '#0071bc' : '#e9ebec'};
	text-transform: none;
	box-shadow: none;
`;
